import api from "../../../services/api";

const APIS = {
  NOTIFICATION_LIST: "/Notify",
  NOTIFICATION_READ: "/Notify",
};

export const getNotificationListData = async (params) => {
  try {
    const response = await api.get(APIS.NOTIFICATION_LIST, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching Notification list data:", error);
     throw error;
  }
};

export const updateNotificationListData = async ({ notificationId }) => {
  try {
    const response = await api.put(`${APIS.NOTIFICATION_READ}?notificationId=${notificationId}`);
    return response.data;
  } catch (error) {
    console.error("Error updating notification:", error);
  }
};